export const API_URL = '/api';
export const API_KEY = 'mock-api-key'; // Replace if needed

export const ENDPOINTS = {
    PARSEDOC_PARSE: '/parsing/parse',
};

export const ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'text/plain',
    'text/markdown',
];

export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
